module.exports = __webpack_public_path__ + "img/5.277b5e64.jpg";